export default {"src":"/_next/static/media/portugal.e09a6905.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};